export default "__VITE_ASSET__3ffed558__"